module.exports = __webpack_public_path__ + "static/media/lightning.5a644d2e.svg";